import { Component, Input, EventEmitter, Output } from '@angular/core';

import { AngularMenuItem } from '../../models';

@Component({
    moduleId: module.id,
    selector: 'angular-menu',
    templateUrl: 'angular-menu.html'
})
export class AngularMenuComponent {
    @Input() menuItemList: AngularMenuItem[] = new Array<AngularMenuItem>();
    @Input() paginaCorrente: string;
    @Input() homePage: string;

    @Output() onMenuItemClick = new EventEmitter();
    @Output() onLogout = new EventEmitter();

    doLogout() {
        this.onLogout.emit();
    }

    doAction(menuItem: AngularMenuItem) {       
        this.onMenuItemClick.emit(menuItem);
    }

    goHome(action: string) {
        let menuItem = new AngularMenuItem();
        menuItem.action = action;
        menuItem.funzione = "Home";
        this.onMenuItemClick.emit(menuItem);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/menu/angular-menu.component.ts